import { render, staticRenderFns } from "./SlaughterReport.vue?vue&type=template&id=0cb04c26&"
import script from "./SlaughterReport.vue?vue&type=script&lang=js&"
export * from "./SlaughterReport.vue?vue&type=script&lang=js&"
import style0 from "./SlaughterReport.vue?vue&type=style&index=0&id=0cb04c26&prod&lang=css&"
import style1 from "./SlaughterReport.vue?vue&type=style&index=1&id=0cb04c26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports